<template>
  <div>
    <v-card class="mb-3">
     <v-text-field 
       solo
       append-icon="search"
       label="Rechercher un produit"
       hide-details
       clearable
       v-model="search"
     ></v-text-field>
    </v-card>
    <v-card class="mb-3" v-show="selected && selected.length > 0">
              <v-btn
                v-if="checkRouteSendChat"
                @click.stop="pushManyProducts(selected)"
                @mouseover="overMenu = true"
                @mouseleave="overMenu = false"
                :color="'secondary--text'"
                icon
                
              >
                ENVOYER TOUS LES PRODUITS SELECTIONNES
                <v-icon>shopping_cart_checkout</v-icon>
              </v-btn>
              <v-btn
                v-else
                @click.stop="pushManyProducts(selected)"
                @mouseover="overMenu = true"
                @mouseleave="overMenu = false"
                :color="status === 'offline' ? 'grey--text' : 'secondary--text'"
                icon
                
              >
				ENVOYER TOUS LES PRODUITS SELECTIONNES
                <v-icon>shopping_cart_checkout</v-icon>
              </v-btn>
    </v-card>
    <v-card class="mb-3 listProductsCatalog" v-show="!!search && search !== ''">
      <v-card-text>
        <v-data-table
          v-model="selected"
          :headers="headersTousProducts"
          :items="allProducts"
          :no-data-text="$tc('allProducts', 0)"
          :no-results-text="$tc('results', 0)"
          :rows-per-page-items="[10, 25, 50, { text: 'Toutes', value: -1 }]"
          :rows-per-page-text="$t('productsPerPage')"
          :search="search"
          :custom-filter="filterLMessages"
          item-key="id"
          select-all
        >
          <template slot-scope="props">
            <tr>
              <th>
                <v-checkbox
                  :input-value="props.all"
                  :indeterminate="props.indeterminate"
                  primary
                  hide-details
                  @click.stop="toggleAll"
                ></v-checkbox>
              </th>
              <th
                v-for="header in props"
                :key="header.text"
                :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>

          <template slot="items" slot-scope="props">
            <td class="text-xs-right">
              <v-checkbox
                v-model="props.selected"
                primary
                hide-details
              ></v-checkbox>
            </td>
            <td class="text-xs-left" @click.stop="">{{ props.item.title }}</td>
            <td class="text-xs-left" @click.stop="">{{ props.item.ref }}</td>
            <td class="text-xs-left" @click.stop="">{{ props.item.keywords }}</td>
            <td class="text-xs-left" @click.stop="">{{ props.item.price }}</td>
	     
            <td class="text-xs-right px-0">
              <v-btn
                v-if="checkRouteSendChat"
                @click.stop="pushProduct(props.item)"
                @mouseover="overMenu = true"
                @mouseleave="overMenu = false"
                :color="'secondary--text'"
                icon
                small
              >
                <v-icon>shopping_cart_checkout</v-icon>
              </v-btn>
              <v-btn
                v-else
                @click.stop="pushProduct(props.item)"
                @mouseover="overMenu = true"
                @mouseleave="overMenu = false"
                :color="status === 'offline' ? 'grey--text' : 'secondary--text'"
                icon
                small
              >
                <v-icon>shopping_cart_checkout</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-expansion-panel expand v-show="!search || search === ''">
      <v-expansion-panel-content v-for="rayon in rayons" :key="rayon.id">
        <div slot="header">
          <v-icon color="primary">store</v-icon>
          {{ rayon.title }}
          <span class="caption grey--text text--darken-1">
            (
            {{ $tc('subRayons', rayon.subs.length, { count: rayon.subs.length }) }} ; 
            {{ $tc('products', rayon.products.length, { count: rayon.products.length }) }}
            )
          </span>
        </div>
        <!-- SOUS-RAYONS -->
        <v-card>
          <v-card-text class="grey lighten-3 px-1">
            <v-expansion-panel v-if="rayon.subs.length" expand>
              <v-expansion-panel-content v-for="sub in rayon.subs" avatar :key="sub.id">
                <div slot="header">
                  <v-icon color="primary">shopping_basket</v-icon>
                  {{sub.title}}
                  <span class="caption grey--text text--darken-1">
                    ({{ $tc('products', sub.products.length, {count: sub.products.length}) }})
                  </span>
                </div>
                <!-- PRODUITS DU SOUS-RAYONS -->
                <v-card>
                  <v-card-text class="grey lighten-3 pl-1 pr-2">
                    <v-list v-if="sub.products.length" two-line dense subheader>
                      <v-list-tile
                        v-for="product in sub.products"
                        :key="product.id"
                        @click="status === 'offline' ? ';' : pushProduct(product)"
                      >
                        <v-list-tile-content>
                          <v-list-tile class="grow">
                            <v-list-tile-avatar color="grey darken-3">
                              <v-img
                                class="elevation-6"
                                :src="product.img"
                              ></v-img>
                            </v-list-tile-avatar>
	                     
                            <v-list-tile-content>
                              <v-list-tile-title>{{product.title}} / {{product.price}}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-btn
                            v-if="checkRouteSendChat"
                            @click.stop="pushProduct(product)"
                            @mouseover="overMenu = true"
                            @mouseleave="overMenu = false"
                            :color="'secondary--text'"
                            icon
                            small
                          >
                            <v-icon>shopping_cart_checkout</v-icon>
                          </v-btn>
                          <v-btn
                            v-else
                            @click.stop="pushProduct(product)"
                            @mouseover="overMenu = true"
                            @mouseleave="overMenu = false"
                            :color="status === 'offline' ? 'grey--text' : 'secondary--text'"
                            icon
                            small
                          >
                            <v-icon>shopping_cart_checkout</v-icon>
                          </v-btn>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-card-text>
        </v-card>
        <!-- PRODUITS DU RAYONS -->
        <v-card>
          <v-card-text class="grey lighten-3 px-1">
            <v-list v-if="rayon.products.length" two-line dense subheader>
              <v-list-tile
                v-for="product in rayon.products"
                :key="product.id"
                @click="status === 'offline' ? ';' : pushProduct(product)"
              >
                <v-list-tile-content>
                  <v-list-tile class="grow">
                    <v-list-tile-avatar color="grey darken-3">
                      <v-img
                        class="elevation-6"
                        :src="product.img"
                      ></v-img>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{product.title}} / {{product.price}}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn
                    v-if="checkRouteSendChat"
                    @click.stop="pushProduct(product)"
                    @mouseover="overMenu = true"
                    @mouseleave="overMenu = false"
                    :color="'secondary--text'"
                    icon
                    small
                  >
                    <v-icon>shopping_cart_checkout</v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    @click.stop="pushProduct(product)"
                    @mouseover="overMenu = true"
                    @mouseleave="overMenu = false"
                    :color="status === 'offline' ? 'grey--text' : 'secondary--text'"
                    icon
                    small
                  >
                    <v-icon>shopping_cart_checkout</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  props: {},
  data () {
    return {
      overMenu: false,
      href: '',
      search: '',
      selected: [],
      allProducts: [{ ref: '', title: '', shortdesc: '', keywords: '', price: '' }],
      headersTousProducts: [
        {text: 'Nom', value: 'title', align: 'left'},
        {text: 'Référence', value: 'ref', align: 'left'},
        {text: 'Mots clés', value: 'keywords', align: 'left'},
        {text: 'Prix', value: 'price', align: 'left'},
        {text: '', value: 'actions', sortable: false, align: 'left'}
      ]
    }
  },

  computed: {
    ...mapGetters('_User', ['user', 'fullName']),
    ...mapGetters('_StoreWatcheeBox', ['WATCHEEBOX_STATE']),
    ...mapState('_StoreWatcheeBox', ['status', 'sessionVisioconf']),
    ...mapState('_Rayons', ['rayons']),
    ...mapState('_Sites', ['sites']),
    // check sur quelle route ce trouve l'agent
    // car il est possible d'envoyer un message sur les route 'attente' et 'contact' même en status 'offline'
    checkRouteSendChat () {
      if (this.$route.fullPath === '/trafic/attente' || this.$route.fullPath === '/trafic/contact' || this.directChat) {
        return true
      } else {
        return false
      }
    }
  },

  created () {
    this.getAllProducts()
  },
  mounted () {},
  beforeDestroy () {},

  methods: {
    // --------------------------------------------------------
    // version iframe de la visio
    // --------------------------------------------------------
    getAllProducts () {
      this.allProducts = _.cloneDeep(this.$store.state._Rayons.allproducts)
    },
    // envois une fiche produits au visiteur
    pushProduct (product) {
      // sur les autres pages, pas d'envois de message offline
      if (this.status === 'offline') {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('currentlyOfflineProduct'),
          context: 'error'
        })
        return
      }

      let productCard = ' <div class="tf-carousel-products">'
      productCard += ' <div class="pushProduct elevation-2 v-card v-sheet theme--light">'
      productCard += '    <div onclick="window.open(\'' + product.link + '\', \'\', \'width=500, height=600\')">'
      productCard += '     <div class="v-responsive v-image" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">'
      productCard += '       <div class="v-responsive__sizer" style="padding-bottom: 31.746%;"></div>'
      productCard += '       <div class="v-image__image v-image__image--cover" style="background-image: url(\'' + product.img + '\'); background-position: center center;"></div>'
      productCard += '     </div>'
      productCard += '     <div class="v-card__title v-card__title--primary">'
      productCard += '       <div class="text-xs-left">'
      productCard += '         <div class="headline mb-0 font-weight-bold title">' + product.title + '</div>'
      productCard += '         <div class="py-2 lignes-3">' + product.shortdesc + '</div>'
      productCard += '         <div class="font-weight-bold">' + product.price + '</div>'
      productCard += '        </div>'
      productCard += '     </div>'
      productCard += '   </div>'

      if (product.addtocart) {
        productCard += '    <div class="v-card__actions">'
        productCard += '     <button type="button" class="v-btn v-btn--small theme--light info productRefBtn_' + product.ref + '" onclick="wzAddToCart(' + product.ref + ', ' + this.$store.state._User.id + ')">'
        productCard += '        <div class="v-btn__content productRefLabel_' + product.ref + '">Ajouter au panier</div>'
        productCard += '     </button>'
        productCard += '    </div>'
      }
      productCard += '  </div>'
      productCard += '</div>'
      // sinon 'online' ou 'busy' envois message
      this.$emit('pushproduct', { message: productCard })
    },
    pushManyProducts (selected) {
      // sur les autres pages, pas d'envois de message offline
      if (this.status === 'offline') {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('currentlyOfflineProduct'),
          context: 'error'
        })
        return
      }
      let productCard = '<div class="tf-carousel-products">'
      selected.forEach(prod => {
        productCard += ' <div class="pushProduct elevation-2 v-card v-sheet theme--light">'
        productCard += '    <div onclick="window.open(\'' + prod.link + '\', \'\', \'width=500, height=600\')">'
        productCard += '     <div class="v-responsive v-image" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">'
        productCard += '        <div class="v-responsive__sizer" style="padding-bottom: 31.746%;"></div>'
        productCard += '       <div class="v-image__image v-image__image--cover" style="background-image: url(\'' + prod.img + '\'); background-position: center center;"></div>'
        productCard += '     </div>'
        productCard += '     <div class="v-card__title v-card__title--primary">'
        productCard += '       <div class="text-xs-left">'
        productCard += '         <div class="headline mb-0 font-weight-bold title">' + prod.title + '</div>'
        productCard += '         <div class="py-2 lignes-3">' + prod.shortdesc + '</div>'
        productCard += '         <div class="font-weight-bold">' + prod.price + '</div>'
        productCard += '        </div>'
        productCard += '     </div>'
        productCard += '   </div>'

        productCard += '    <div class="v-card__actions">'
        productCard += '     <button type="button" class="v-btn v-btn--small theme--light info productRefBtn_' + prod.ref + '" onclick="wzAddToCart(' + prod.ref + ', ' + this.$store.state._User.id + ')">'
        productCard += '        <div class="v-btn__content productRefLabel_' + prod.ref + '">Ajouter au panier</div>'
        productCard += '     </button>'
        productCard += '    </div>'

        productCard += '  </div>'
      })
      productCard += '</div>'
      // sinon 'online' ou 'busy' envois message
      this.$emit('pushproduct', { message: productCard })
    },
    /**
     * Fonction de filtrage
     */
    filterLMessages (items, search, filter) {
      if (_.isNil(search)) return items
      search = search.toString().toLowerCase()
      items = items.filter(i => (
        Object.keys(i).some(j => filter(i[j], search))
      ))
      return items
    }
  }
}

</script>

<style>
.listProductsCatalog .v-input--selection-controls {
  margin-top: 0px !important;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/watcheebox/WzCatalogueProduits.vue